var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTierraOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5232_26868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.645996 31.2C1.246 47.2 14.446 60 30.646 60C47.246 60 60.646 46.8 60.646 30.2V0.2C60.646 0.2 60.646 0.2 60.446 0.2C43.846 0.2 30.446 13.6 30.446 30.2V30.4C30.446 30.4 30.446 30.4 30.446 30.2C30.446 13.6 17.246 0 0.645996 0V31.2Z",
    fill: "#FF972F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5232_26868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.645996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierraOrange);
export default __webpack_public_path__ + "static/media/tierra-orange.4025b22c9506164990c4df820e34bd9b.svg";
export { ForwardRef as ReactComponent };